var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40039 2.09961C2.29582 2.09961 1.40039 2.99504 1.40039 4.09961L1.40039 9.89961C1.40039 11.0042 2.29582 11.8996 3.40039 11.8996L10.6004 11.8996C11.705 11.8996 12.6004 11.0042 12.6004 9.89961L12.6004 4.09961C12.6004 2.99504 11.705 2.09961 10.6004 2.09961L3.40039 2.09961ZM6.30039 5.94961C6.30039 6.52951 5.83029 6.99961 5.25039 6.99961C4.67049 6.99961 4.20039 6.52951 4.20039 5.94961C4.20039 5.36971 4.67049 4.89961 5.25039 4.89961C5.83029 4.89961 6.30039 5.36971 6.30039 5.94961ZM5.60039 7.69961L3.15039 9.79961L11.5504 9.79961L8.88735 6.64961L7.06126 8.39961L5.60039 7.69961Z",
    fill: "#605D62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.6d25acaed3112d393f475778f1d2b644.svg";
export { ForwardRef as ReactComponent };